import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const professionalExperienceSchema = z.object({
  id: z.string().optional(),
  title: z.string().min(1),
  company: z.string().min(1),
  location: z.string().optional().default(""),
  startDate: z.string().optional().default(""),
  endDate: z.string().optional().default(""),
  current: z.boolean().optional().default(false),
  summary: z.string().optional().default(""),
});

export const professionalEducationSchema = z.object({
  id: z.string().optional(),
  institution: z.string().min(1),
  studyType: z.string().optional().default(""),
  area: z.string().optional().default(""),
  startDate: z.string().optional().default(""),
  endDate: z.string().optional().default(""),
  summary: z.string().optional().default(""),
});

export const professionalSkillSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  description: z.string().optional().default(""),
  level: z.number().min(1).max(5).default(1),
  keywords: z.array(z.string()).default([]),
});

export const professionalCertificationSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1),
  issuer: z.string().optional().default(""),
  date: z.string().optional().default(""),
  summary: z.string().optional().default(""),
});

export const professionalProfileSchema = z.object({
  id: z.string().optional(),
  headline: z.string().optional().default(""),
  summary: z.string().optional().default(""),
  location: z.string().optional().default(""),
  website: z.string().optional().default(""),
  phone: z.string().optional().default(""),
  linkedin: z.string().optional().default(""),
  github: z.string().optional().default(""),
  portfolioUrl: z.string().optional().default(""),
  experiences: z.array(professionalExperienceSchema).default([]),
  educations: z.array(professionalEducationSchema).default([]),
  skills: z.array(professionalSkillSchema).default([]),
  certifications: z.array(professionalCertificationSchema).default([]),
});

export class ProfessionalProfileDto extends createZodDto(professionalProfileSchema) {}
export class ProfessionalExperienceDto extends createZodDto(professionalExperienceSchema) {}
export class ProfessionalEducationDto extends createZodDto(professionalEducationSchema) {}
export class ProfessionalSkillDto extends createZodDto(professionalSkillSchema) {}
export class ProfessionalCertificationDto extends createZodDto(professionalCertificationSchema) {}
